import { monotonicFactory } from 'ulidx';

/**
 * All internal IDs are ULIDs (sortable, no coordination needed).
 * External identifiers (WhatsApp numbers, emails) are never keys —
 * they live in the identifiers table (CLAUDE.md #9).
 */
const ulid = monotonicFactory();

export function newId(): string {
  return ulid();
}
